import { render, staticRenderFns } from "./class-attendance.vue?vue&type=template&id=d1f5dce0&"
import script from "./class-attendance.vue?vue&type=script&lang=js&"
export * from "./class-attendance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports